export default function Footer() {
  return (
    <footer className="bg-black border-t border-[#00f0ff]/20 py-6 md:py-8">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-3 md:gap-4 text-center md:text-left">
          <div className="flex items-center gap-2 text-white">
            <span className="text-lg md:text-xl">🎮</span>
            <span className="font-medium text-sm md:text-base">Built by Asher</span>
          </div>

          <div className="text-[#b8b8b8] text-xs md:text-sm">
            © 2025 Asher Reviews. All rights reserved.
          </div>

          <a
            href="https://readdy.ai/?ref=logo"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#b8b8b8] text-xs md:text-sm hover:text-[#00f0ff] transition-colors duration-300 cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
